import React from 'react'
import {Link} from 'react-router-dom';

class PackageListItem extends React.Component<any, any> {
    render () {
        const {item} = this.props
        return <div className='package-detail'>
        <div className='left'>
            <p className='package-name'>{item.name}</p>
            <p className='package-intro'>{item.info}</p>
            <p className='package-other-info'>
                <span>下载量: <label className=''>{item.download || 0}</label></span>
                <span>版本: <label>{item.latestVersion || '--'}</label></span>
                {/* <span>来源: {item.nexus === 'ynpm' ? 'YNPM源': item.nexus === 'npm' ? 'NPM源' : '低代码开发平台'}</span> */}
                <span>访问量: <label>{item.visitVolume || '0'}</label></span>
                <span>创建者: <label>{item.creatorName || '系统收录'}</label></span>
            </p>
        </div>
        <div className='right'>
            <Link to={'/package/detail/' + item.name} className="package-item" key={item.name}>
                了解详情
            </Link>
        </div>
    </div>
    }
}

export default PackageListItem
